window.getCookieConsent = function () {
    if (window.UC_UI != null) {
        return {
            necessary: window.UC_UI.getServicesBaseInfo().some(
                (data) => data.categorySlug === 'necessary' && data.consent.status === true,
            ),
            preferences: window.UC_UI.getServicesBaseInfo().some(
                (data) => data.categorySlug === 'functional' && data.consent.status === true,
            ),
            statistics: window.UC_UI.getServicesBaseInfo().some(
                (data) => data.categorySlug === 'statistics' && data.consent.status === true,
            ),
            marketing: window.UC_UI.getServicesBaseInfo().some(
                (data) => data.categorySlug === 'marketing' && data.consent.status === true,
            ),
        };
    }

    // TODO: think about testing in dev mode?!
    return {
        necessary: false,
        preferences: false,
        statistics: false,
        marketing: false,
    };
};

window.checkCookieConsent = function (services) {
    if (!window.UC_UI) {
        // TODO: think about testing in dev mode?!
        return false;
    }

    if (services === 'preferences' || services === 'functional')
        return window.UC_UI.getServicesBaseInfo().some(
            (data) => data.categorySlug === 'functional' && data.consent.status === true,
        );
    if (services === 'statistics')
        return window.UC_UI.getServicesBaseInfo().some(
            (data) => data.categorySlug === 'statistics' && data.consent.status === true,
        );
    if (services === 'marketing')
        return window.UC_UI.getServicesBaseInfo().some(
            (data) => data.categorySlug === 'marketing' && data.consent.status === true,
        );

    if (services.length > 0) {
        return services.every((serviceID) => {
            const service = window.UC_UI.getServicesBaseInfo().find((data) => data.id === serviceID);
            return service?.consent?.status === true;
        });
    }

    return false;
};

window.updateCookieConsent = async function (consent) {
    if (!window.UC_UI) {
        console.warn('Cannot window.updateCookieConsent() - window.UC_UI is not defined');
    }

    const consentServices = Object.keys(consent);

    const services = window.UC_UI.getServicesBaseInfo();

    const acceptServices = [];
    const rejectServices = [];

    consentServices.forEach((service) => {
        if (service === 'preferences' || service === 'functional') {
        }
        if (service === 'marketing') {
        }
        if (service === 'statistics') {
        }
        // else assume service id

        if (consent[service] === true) {
            acceptServices.push(service);
        } else {
            rejectServices.push(service);
        }
    });

    if (acceptServices.length > 0) {
        await UC_UI.acceptServices(acceptServices);
    }

    if (rejectServices.length > 0) {
        await UC_UI.rejectServices(rejectServices);
    }
};

function handleCookieConsentChange() {
    const event = new CustomEvent('cookie-consent-change', {
        bubbles: true,
        cancelable: true,
        composed: true,
        detail: window.getCookieConsent(),
    });
    document.dispatchEvent(event);
}

// Attention! the ucEvent name must be configured in the usercentrics dashboard - there is no default event...
window.addEventListener('ucEvent', (e) => {
    handleCookieConsentChange();
});

window.addEventListener('UC_UI_INITIALIZED', (e) => {
    handleCookieConsentChange();
});
